module.exports = __webpack_public_path__ + "static/media/ido-congrat.a995d491.svg";